import "@/styles/vendor.css";
import "@/styles/index.css";

import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import modal from "@/scripts/components/modal";
import pageHeader from "@/scripts/components/page-header";
import paginatedList from "@/scripts/components/paginated-list";
import parallaxImages from "@/scripts/components/parallax-images";
import parallaxShapes from "@/scripts/components/parallax-shapes";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import siteMenu from "@/scripts/components/site-menu";
import slideToggle from "@/scripts/components/slide-toggle";
import tooltip from "@/scripts/components/tooltip";
import { initGoogleTranslateWidget } from "@/scripts/components/google-translate-widget";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import mask from "@alpinejs/mask";
import { pillMarker } from "@/scripts/alpine/pill-marker";

window.Alpine = Alpine;

form.init();
mediaSlider.init();
modal.init();
pageHeader.init();
paginatedList.init();
parallaxImages.init();
parallaxShapes.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
siteMenu.init();
slideToggle.init();
tooltip.init();

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(mask);
Alpine.data("pillMarker", pillMarker);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  initGoogleTranslateWidget();

  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
